import { ThemeUICSSObject, responsive } from '@apia/theme';

export const gridSpan = responsive({
  0: 'span 1',
  3: 'span 2',
  4: 'span 4',
});

export const semanticSearch: ThemeUICSSObject = {
  docTypeDataSource: {
    foldersComponent: {
      '.foldersTable': {
        variant: 'layout.design.semanticSearch.attributesTable',
        '.options': {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-evenly',
        },
      },
      '.folderInput': {
        display: 'flex',
        height: '53px',
        button: { minWidth: '152px' },
      },
    },
    '.docTypeList': {
      listStyleType: 'disc',
      paddingLeft: '1.5rem',
    },
    '&.doc_type_datasource__factory_selector': {},
    '&.doc_type_datasource__extractor_selector': {
      //order: 999,
    },
    '.doc_type_datasource__extractor_selector__parameters': {
      marginLeft: '23px',
      marginRight: '17px',
      listStyleType: 'disc' /* o circle, square, etc. */,
    },
    '.doc_type_datasource__extractor_selector__parameter': {},
  },
  entitiesDataSource: {
    '.entityBox': { marginBottom: '10px' },
  },
  '.validationsForm': {
    marginBottom: '18px',
  },

  upsertion: {
    variant: 'layout.common.upsertion',

    '.genericModal__withBoxes__addButton': {
      alignSelf: 'baseline',
    },
    '.scheduler_box': {
      display: 'flex',
      flexDirection: 'column',
    },
    '.scheduler_box_childs': {
      display: 'flex',
      minWidth: '53vw',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    'label[name="dataSource.scheduler.nodeType"]': {
      minWidth: '12vw',
    },
    '.subtitle': {
      gridColumn: gridSpan,
    },
  },

  attributesTable: {
    variant: 'layout.common.tables.secondary',
    marginBottom: '7px',
    '.trash__icon': {
      paddingLeft: '7%',
      textAlign: 'center',
      verticalAlign: 'middle',
    },
    td: {
      textAlign: 'center',
      '&:first-of-type': {
        textAlign: 'left',
      },
    },
  },

  datasourceFieldSet: {
    '.dataSourceParameters': {
      gridColumn: gridSpan,
      display: 'flex',
      flexDirection: 'column',
      gap: 3,
    },
    '.pipelineElements': { gridColumn: gridSpan },
    '.filterElements': { gridColumn: gridSpan },
  },

  addPipEleForm: {
    display: 'flex',
    flexDirection: 'column',
    gap: 5,

    '& > div': {
      display: 'flex',
      flexDirection: 'column',
      gap: 3,
    },

    textarea: {
      height: '50vh',
    },
    '.addPipEleForm__mainFields__typeBox': {
      display: 'flex',
      gap: 1,
      alignItems: 'center',
      width: '100%',
      justifyContent: 'space-between',
      div: {
        width: '100%',
      },
      '.infoButton': {
        width: '51px',
        height: '50px',
      },
    },
  },

  pipeline: {
    display: 'flex',
    flexDirection: 'column',
    gap: 3,
    gridColumn: gridSpan,

    h3: {},

    '.addPipelineElement': {
      alignSelf: 'baseline',
    },

    '.pipEleTable': {
      variant: 'layout.common.tables.secondary',
      width: '100%',
      borderCollapse: 'collapse',

      '& > tbody tr td, & > tbody tr th': {
        border: 'none',
      },

      tr: {
        borderBottom: '1px solid',
        borderBottomColor: 'palette.border.section',
      },
    },
    '.options': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-around',
    },
  },

  filterTableBox: {
    display: 'grid',
    marginBottom: '2vh',
    '.filterTableButton': {
      justifySelf: 'left',
      marginTop: '2vh',
    },
    '.filterRowOption': {
      alignSelf: 'center',
      justifySelf: 'center',
    },
    '.trash__button:is(.pipEleTable *)': {
      textAlign: 'center',
      verticalAlign: 'middle',
    },
  },
  filterBox: {
    '.multiplesValuesBox': {
      display: 'flex',
      alignItems: 'center',
      marginTop: '10px',
      marginBottom: '10px',
    },
    '.iconButton': {
      width: '46px',
      height: '46px',
    },
  },
  edit: {
    visibilityGroups: {
      gridColumn: gridSpan,

      form: {
        display: 'flex',
        flexDirection: 'column',
        gap: 5,
      },

      '.groups__list': {
        display: 'flex',
        flexDirection: 'column',

        li: {
          borderBottom: '1px solid',
          borderBottomColor: 'palette.border.section',
          py: 3,

          '&:first-of-type': {
            pt: 0,
          },

          '&:last-of-type': {
            borderBottom: 'none',
            pb: 0,
          },
        },

        '.genericModal__withBoxes__fieldWrapper': {
          alignItems: 'center',
          flexDirection: 'row',

          button: {
            flexShrink: 0,
          },
        },

        '.genericModal__withBoxes__boxes': {
          display: 'flex',
          gap: 3,
          flexWrap: 'wrap',

          '.labelBox > div > .closeButton': {
            height: '24px',
            width: '24px',

            svg: {
              height: '16px',
              width: '16px',
            },
          },
        },

        '.group__buttons': {
          display: 'flex',
          gap: 3,
        },
      },

      '.add-visibility-group': {
        alignSelf: 'start',
      },
    },
  },
  processors: {
    indexing: {
      generic: {
        modalWithBoxes: {
          itemRender: {
            '.genericModal__withBoxes__boxes': {
              gridTemplateColumns: 'none !important',
              //backgroundColor: 'red',
            },
          },
        },
      },
    },
    recover: {},
    queryTableListBox: {
      display: 'flex',
      flexDirection: 'column',
      gap: 4,
      ul: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: 4,
      },
      li: { width: 'fit-content' },
      '& button:last-of-type': {
        width: 'fit-content',
      },
    },
  },
};
